import axios from 'axios'

// 创建axios实例
const sippushservice = axios.create({
  baseURL: 'http://sip.wecare-u.net',
  timeout: 61000
})

// request拦截器
sippushservice.interceptors.request.use(config => {
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
sippushservice.interceptors.response.use(
  response => {
    // console.log(response.data)
    return response.data
  },
  error => {
    console.log('err' + error)// for debug
    return Promise.reject(error)
  }
)

export default sippushservice



// WEBPACK FOOTER //
// ./src/sip/sip_push_axios.js